import { takeEvery, call, put, select } from "redux-saga/effects";
import actionTypes from "_constants/actionTypes";
import { service } from "../_services/service";
import { history } from "_helpers/history";
export default function* watcherWorkcenters() {
    yield takeEvery(actionTypes.GET_WORKCENTER, getWorkcenter);
    yield takeEvery(actionTypes.GET_WORKCENTERS, getWorkcenters);
    yield takeEvery(actionTypes.SAVE_WORKCENTER, saveWorkcenter);
    yield takeEvery(actionTypes.NEW_WORKCENTER, newWorkcenter);
    yield takeEvery(actionTypes.RESEND_WORKCENTER, resend);
    
}



function* resend(payload) {
  yield put({ type: actionTypes.START_REQUEST });

 try {
   let apiEndpoint = "/v1/workcenters/resend/" + payload.payload;
   const res = yield call(
     () =>
       new Promise((resolve, reject) => {
         service.putToken(apiEndpoint).then((response) => {
           resolve(response);
         });
       })
   );
   if (res.status === 200) {
     yield put({
       type: actionTypes.RESEND_WORKCENTER_DATA,
       payload: res.data,
     });
     yield put({
       type: actionTypes.CLEAR_DATA_WORKCENTER,
       payload: null,
     });


   } else {
     yield put({
       type: actionTypes.RESEND_WORKCENTER_ERROR,
       payload: res.data,
     });
   }
 } catch (e) {
   yield put({ type: actionTypes.RESEND_WORKCENTER_ERROR, payload: e });
 }
 yield put({ type: actionTypes.END_REQUEST });
}

function* getWorkcenter(payload) {
   yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/workcenters/workcenter/" + payload.payload;
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          service.getToken(apiEndpoint).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({
        type: actionTypes.GET_WORKCENTER_DATA,
        payload: res.data,
      });
      yield put({
        type: actionTypes.CLEAR_DATA_WORKCENTER,
        payload: null,
      });


    } else {
      yield put({
        type: actionTypes.GET_WORKCENTER_ERROR,
        payload: res.data,
      });
    }
  } catch (e) {
    yield put({ type: actionTypes.GET_WORKCENTER_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}

function* saveWorkcenter({payload}) {
  console.log(payload);
  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/workcenters/workcenter/" + payload.id;
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          service.putToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({
        type: actionTypes.SAVE_WORKCENTER_DATA,
        payload: res.data,
      });


      yield put({
        type: actionTypes.CLEAR_DATA_WORKCENTER,
        payload: null,
      });
      
    } else {
      yield put({
        type: actionTypes.SAVE_WORKCENTER_ERROR,
        payload: res.data,
      });
    }
  } catch (e) {
    yield put({ type: actionTypes.SAVE_WORKCENTER_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* newWorkcenter({ payload }) {
  console.log(payload);
  yield put({ type: actionTypes.START_REQUEST });

  try {
    let apiEndpoint = "/v1/workcenters/workcenter";
    console.log(payload);
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          service.postToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      console.log(res);
      yield put({
        type: actionTypes.NEW_WORKCENTER_DATA,
        payload: res.data,
      });

      yield put({
        type: actionTypes.CLEAR_DATA_WORKCENTER,
        payload: null,
      });

    } else {
      console.log(res);
      yield put({
        type: actionTypes.NEW_WORKCENTER_ERROR,
        payload: res.data,
      });
    }
  } catch (e) {
    yield put({ type: actionTypes.NEW_WORKCENTER_ERROR, payload: e });
  }
  yield put({ type: actionTypes.END_REQUEST });
}


function* getWorkcenters() {
    yield put({ type: actionTypes.START_REQUEST });
   
    try {
      let apiEndpoint = "/v1/workcenters";
      const res = yield call(
        () =>
          new Promise((resolve, reject) => {
            service.getToken(apiEndpoint).then((response) => {
              resolve(response);
            });
          })
      );
      if (res) {
        if (res.status && res.status === 200 ) {
          yield put({ type: actionTypes.GET_WORKCENTERS_DATA, payload: res.data });
        } else {
          yield put({ type: actionTypes.GET_WORKCENTERS_ERROR, payload: "Error" });
        }
      } else {
        yield put({
          type: actionTypes.GET_WORKCENTERS_ERROR,
          payload: "Error",
        });
      }
    } catch (e) {
      yield put({
        type: actionTypes.GET_WORKCENTERS_ERROR,
        payload: "Error",
      });
    }
    yield put({ type: actionTypes.END_REQUEST });
  }